import React from 'react';
import NavigationView from './navigation-view';
import useReminders from '../../hooks/use-reminders';
import { useAuthStore } from '../../store';

const NavigationContainer = () => {
  const { loggedInAgent } = useAuthStore();
  const { hasReminders } = useReminders({
    assignee: loggedInAgent?.id,
  });

  return <NavigationView hasReminders={hasReminders} />;
};

export default NavigationContainer;
